import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/mutations';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Gateway-Allowlist (cs.api.valitype.net). Manuelle IP-Freigaben, die der
 * Kong-Sync-CronJob mit den NetBox-Tag-IPs zur effektiven ip-restriction-
 * Allowlist merged. M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  items: [
    { id: 1, ip: '203.0.113.10', cidr: '203.0.113.10/32', label: 'Büro Nürnberg', created_by: 'operator', created_at: new Date().toISOString() },
  ],
};

export function useManualAllowlist() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['gateway-allowlist', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/gateway-allowlist');
    },
    refetchInterval: 60_000,
  });
}

export function useEffectiveAllowlist() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['gateway-allowlist-effective', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return { allowlist: ['203.0.113.10/32', '10.20.30.41/32'], sources: { manual: 1, netbox: 1, netboxError: null } }; }
      return nexusFetch('/v1/admin/gateway-allowlist/effective');
    },
    refetchInterval: 60_000,
  });
}

export function useAddAllowlistIp() {
  return useApiMutation({
    live: (_fetch, { value, label }) =>
      nexusFetch('/v1/admin/gateway-allowlist', { method: 'POST', body: { value, label } }),
    fixture: ({ value }) => ({ id: Date.now(), cidr: value }),
    invalidate: ['gateway-allowlist', 'gateway-allowlist-effective'],
    successMessage: (_, { value }) => `${value} zur Allowlist hinzugefügt.`,
  });
}

export function useRemoveAllowlistIp() {
  return useApiMutation({
    live: (_fetch, { id }) =>
      nexusFetch(`/v1/admin/gateway-allowlist/${encodeURIComponent(id)}`, { method: 'DELETE' }),
    fixture: ({ id }) => ({ ok: true, id }),
    invalidate: ['gateway-allowlist', 'gateway-allowlist-effective'],
    successMessage: () => 'IP entfernt.',
  });
}
